import { render, staticRenderFns } from "./BankAvatar.vue?vue&type=template&id=426473cd&scoped=true"
import script from "./BankAvatar.vue?vue&type=script&lang=ts"
export * from "./BankAvatar.vue?vue&type=script&lang=ts"
import style0 from "./BankAvatar.vue?vue&type=style&index=0&id=426473cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426473cd",
  null
  
)

export default component.exports